var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 13,
    viewBox: "0 0 23 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-7h25v25H-2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#798FD6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M.344 6.282h20.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.188.813l5.469 5.469-5.469 5.469"
  })))));
}

export default SvgArrowRight;